import React, { memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';

import { useGetUserPlanInfo } from 'modules/user';
import { SubscriptionApi } from 'modules/subscription/api';
import { Button } from 'modules/ui/components';
import { HighlightedSm } from 'modules/ui/typography';
import { Subtitle } from '../Subtitle';
import { InfoRow, InfoLabel, InfoValue, ActionsRow } from './styledComponents';

const SubscriptionSideMenuSectionUi: React.FC = () => {
  const { name, period, subscriptionEndsAt, isFree } = useGetUserPlanInfo();
  const history = useHistory();

  const handleManageSubscription = useCallback(async (): Promise<void> => {
    const { url } = await SubscriptionApi.getPortalLink();
    window.open(url, '_blank');
  }, []);

  const handleUpgrade = useCallback((): void => {
    history.push('/upgrade');
  }, [history]);

  return (
    <>
      <Subtitle addTopPadding>Subscription</Subtitle>
      <InfoRow>
        <InfoLabel>Plan&nbsp;</InfoLabel>
        <HighlightedSm>
          {name} / {period}
        </HighlightedSm>
      </InfoRow>
      {subscriptionEndsAt && (
        <InfoRow>
          <InfoLabel>Renews / Expires&nbsp;</InfoLabel>
          <InfoValue>
            {format(new Date(subscriptionEndsAt), 'MMM d, yyyy')}
          </InfoValue>
        </InfoRow>
      )}
      <ActionsRow>
        <Button
          stretch
          isSecondary
          label={isFree ? 'Upgrade' : 'Manage subscription'}
          clickHandler={isFree ? handleUpgrade : handleManageSubscription}
        />
      </ActionsRow>
    </>
  );
};

export const SubscriptionSideMenuSection = memo(SubscriptionSideMenuSectionUi);
